<template>
  <div class="javaStudyPathWidge">
    <div class="conts">
      <div class="studyRoute">
        <div class="outlineBox">
          <el-tabs
            :tab-position="tabPosition"
            style="height: 659px;"
            @tab-click="handleClick"
          >
            <el-tab-pane label v-for="(item, index) in tableData" :key="index" :index="String(index)">
              <div slot="label" class="outlineTitle">
                <p>{{ item.title }}</p>
                <span :title="item.subTitle">{{ item.subTitle }}</span>
              </div>
              <div class="outlineeInfo">
                <div v-for="(val, num) in strToArr(item.desc)" :key="num">
                  <em class="courseOutTitle">{{ val.title }}</em>
                  <ul class="courseOutList">
                    <li v-for="(v, n) in val.content" :key="n" :title="v">
                      {{ v }}
                    </li>
                  </ul>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- <div class="divStudyBtn" @click="qimoChatClick"> 马上学习 </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { elTabsAddEventListener } from "./../../../../js/tools";
export default {
  components: {
  },
  data() {
    return {
      tabPosition: "left",
      tableData: [],
    };
  },
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  mounted(){
    this.tableData = this.data
    setTimeout(() => {
      if (this.tableData){
        elTabsAddEventListener(document, this.tableData.length);
      }
    }, 1000);
  },
  methods: {
    handleClick(val) {
      this.$trackEvent(
        this.tableData[val.index].titles,
        "点击",
        this.tableData[val.index].titles
      );
    },
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击", "马上学习");
      window.qimoChatClick();
    },
  },
};
</script>

<style lang="scss">
@import "./javaStudyPathWidge.scss";
</style>
